import React from 'react';
import Alert from 'components/error/Error';
import { useSignInLogic } from './SignIn.hook';
import SignInForm from './components/singinform/SignInForm';
import { LivenHeaderWrapper } from 'onboarding/LivenHeaderWrapper';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import styles from './styles.module.scss';
import 'common.scss';

const LivenSignIn = () => {
  const { isErrorVisible, onErrorVisibleHandler, errorMessage, ...otherProps } =
    useSignInLogic();

  return (
    <div className={styles.template}>
      <Alert
        visible={isErrorVisible}
        error={errorMessage}
        onClose={onErrorVisibleHandler}
      />
      <div className={`${styles.templateContainer} ${styles.signIn}`}>
        <LivenHeaderWrapper
          className={styles.newStepper}
          questionId={QuestionIds.WellbeingQ12}
        />

        <p className={styles.title}>
          Enter your email <br /> to get your personal Plan
        </p>

        <SignInForm {...otherProps} />
      </div>
    </div>
  );
};

export default LivenSignIn;
